/* eslint-disable */
import Vue from 'vue';
import App from './App.vue';
import store from './store';
import vuetify from './plugins/vuetify';

import axios from 'axios';
import VueAxios from 'vue-axios';
import '@mdi/font/css/materialdesignicons.css';

Vue.config.productionTip = false;

Vue.use(VueAxios, axios);

new Vue({
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app');
